var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile-navigation fs-mobile",
      class: { open: _vm.isMobileNavigationOpen },
      attrs: {
        "aria-labelledby": "mobile-navigation-toggler",
        itemscope: "",
        itemtype: "https://schema.org/SiteNavigationElement"
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized"
            }
          ],
          staticClass:
            "d-flex flex-wrap justify-content-between align-content-between nav-wrap"
        },
        [
          _c(
            "ul",
            { staticClass: "breadcrumb d-block px-3 py-0 w-100" },
            [
              _c("li", {
                staticClass: "btn-close",
                attrs: {
                  "aria-label": _vm.$translate("Ceres::Template.closeIcon")
                },
                on: {
                  click: function($event) {
                    return _vm.closeNavigation()
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "breadcrumb-item",
                  on: {
                    click: function($event) {
                      return _vm.slideTo(null, true)
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-home",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.breadcrumbs, function(breadcrumb) {
                return _c(
                  "li",
                  {
                    staticClass: "breadcrumb-item",
                    on: {
                      click: function($event) {
                        return _vm.slideTo(breadcrumb.parent, true)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(breadcrumb.name) + "\n      ")]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass:
                "mainmenu w-100 p-0 m-0 menu-active position-relative abcdef",
              attrs: { id: "menu-1" }
            },
            [
              _vm.dataContainer1.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function($event) {
                          _vm.slideTo(
                            (_vm.dataContainer1.parent &&
                              _vm.dataContainer1.parent.parent) ||
                              null,
                            true
                          )
                        }
                      }
                    },
                    [_vm._m(0)]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer1.categories, function(category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.getCategoryUrl(category.url),
                        itemprop: "name"
                      }
                    },
                    [_vm._v(_vm._s(category.details[0].name))]
                  ),
                  _vm._v(" "),
                  category.childCount
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction",
                          on: {
                            click: function($event) {
                              return _vm.slideTo(category)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-lg fa-caret-right",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    : _vm._e()
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer1.categories[0]
                ? _vm._l(
                    _vm.dataContainer1.categories[0].siblingCount -
                      _vm.dataContainer1.categories.length,
                    function(number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" }
                        })
                      ])
                    }
                  )
                : _vm.dataContainer1.parent
                ? _vm._l(_vm.dataContainer1.parent.childCount, function(
                    number
                  ) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0 position-relative",
              attrs: { id: "menu-2" }
            },
            [
              _vm.dataContainer2.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function($event) {
                          _vm.slideTo(
                            (_vm.dataContainer2.parent &&
                              _vm.dataContainer2.parent.parent) ||
                              null,
                            true
                          )
                        }
                      }
                    },
                    [_vm._m(1)]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer2.categories, function(category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.getCategoryUrl(category.url),
                        itemprop: "name"
                      }
                    },
                    [_vm._v(_vm._s(category.details[0].name))]
                  ),
                  _vm._v(" "),
                  category.childCount
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction",
                          on: {
                            click: function($event) {
                              return _vm.slideTo(category)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-lg fa-caret-right",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    : _vm._e()
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer2.categories[0]
                ? _vm._l(
                    _vm.dataContainer2.categories[0].siblingCount -
                      _vm.dataContainer2.categories.length,
                    function(number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" }
                        })
                      ])
                    }
                  )
                : _vm.dataContainer2.parent
                ? _vm._l(_vm.dataContainer2.parent.childCount, function(
                    number
                  ) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass:
                "mainmenu w-100 p-0 m-0 menu-active position-relative mt-5 test"
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "h4 text-black font-weight-bold mb-2 ml-3 d-block"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "RZOVueJSTheme::Header.MenuAngeboteHeadline"
                      )
                    )
                  )
                ]
              ),
              _vm._v(" "),
              _c("li", { staticClass: "ddown" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.$translate(
                        "RZOVueJSTheme::Header.MenuAngeboteLink1"
                      )
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa ",
                      class: _vm.$translate(
                        "RZOVueJSTheme::Header.MenuAngeboteIcon1"
                      ),
                      attrs: { "aria-hidden": "true" }
                    }),
                    _c("span", { staticClass: "ml-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "RZOVueJSTheme::Header.MenuAngeboteText1"
                          )
                        )
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "ddown" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.$translate(
                        "RZOVueJSTheme::Header.MenuAngeboteLink2"
                      )
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa ",
                      class: _vm.$translate(
                        "RZOVueJSTheme::Header.MenuAngeboteIcon2"
                      ),
                      attrs: { "aria-hidden": "true" }
                    }),
                    _c("span", { staticClass: "ml-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "RZOVueJSTheme::Header.MenuAngeboteText2"
                          )
                        )
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass:
                "mainmenu w-100 p-0 m-0 menu-active position-relative mt-5"
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "h4 text-black font-weight-bold ml-3 d-block mb-2"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "RZOVueJSTheme::Header.MenuContactHeadline"
                      )
                    )
                  )
                ]
              ),
              _vm._v(" "),
              _c("li", { staticClass: "ddown" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.$translate(
                        "RZOVueJSTheme::Header.MenuContactPhoneLink"
                      )
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa ",
                      class: _vm.$translate(
                        "RZOVueJSTheme::Header.MenuContactPhoneIcon"
                      ),
                      attrs: { "aria-hidden": "true" }
                    }),
                    _c("span", { staticClass: "ml-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "RZOVueJSTheme::Header.MenuContactPhoneText"
                          )
                        )
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "ddown" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.$translate(
                        "RZOVueJSTheme::Header.MenuContactWhatsAppLink"
                      )
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa ",
                      class: _vm.$translate(
                        "RZOVueJSTheme::Header.MenuContactWhatsAppIcon"
                      ),
                      attrs: { "aria-hidden": "true" }
                    }),
                    _c("span", { staticClass: "ml-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "RZOVueJSTheme::Header.MenuContactWhatsAppText"
                          )
                        )
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "ddown" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.$translate(
                        "RZOVueJSTheme::Header.MenuContactLink"
                      )
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa ",
                      class: _vm.$translate(
                        "RZOVueJSTheme::Header.MenuContactIcon"
                      ),
                      attrs: { "aria-hidden": "true" }
                    }),
                    _c("span", { staticClass: "ml-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "RZOVueJSTheme::Header.MenuContactText"
                          )
                        )
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "ddown d-none" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.$translate("RZOVueJSTheme::Header.MenuBlogLink")
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa ",
                      class: _vm.$translate(
                        "RZOVueJSTheme::Header.MenuBlogIcon"
                      ),
                      attrs: { "aria-hidden": "true" }
                    }),
                    _c("span", { staticClass: "ml-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("RZOVueJSTheme::Header.MenuBlogText")
                        )
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "w-100 text-center py-5" }, [
            _c("img", {
              staticClass: "img-fluid logo",
              attrs: {
                src: _vm.$translate("RZOVueJSTheme::Header.MenuLogo"),
                alt: "Räder Zentrum Osnabrück"
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("ul", { staticClass: "breadcrumb" }, [
              _c("li", {
                staticClass: "btn-close",
                attrs: {
                  "aria-label": _vm.$translate("Ceres::Template.closeIcon")
                },
                on: {
                  click: function($event) {
                    return _vm.closeNavigation()
                  }
                }
              }),
              _vm._v(" "),
              _vm._m(2)
            ]),
            _vm._v(" "),
            _c("loading-animation")
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "nav-direction btn-up" }, [
      _c("i", {
        staticClass: "fa fa-lg fa-level-up",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "nav-direction btn-up" }, [
      _c("i", {
        staticClass: "fa fa-lg fa-level-up",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("i", { staticClass: "fa fa-home", attrs: { "aria-hidden": "true" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }